import { useSyncExternalStore } from 'react';
import {
    getAudioPrefs,
    subscribeAudioPrefs,
    setMode as storeSetMode,
    setDefaultRest as storeSetDefaultRest,
    setVolume as storeSetVolume,
} from '@/lib/audioCue';

/**
 * Subscribe to the module-level audio-prefs store.
 *
 * Returns the current snapshot plus stable setters. Updates trigger a
 * re-render via `useSyncExternalStore` — no React Context required, so there
 * are no stale closures across render trees.
 */
export function useAudioPrefs() {
    const prefs = useSyncExternalStore(
        subscribeAudioPrefs,
        getAudioPrefs,
        getAudioPrefs
    );
    return {
        ...prefs,
        setMode: storeSetMode,
        setDefaultRest: storeSetDefaultRest,
        setVolume: storeSetVolume,
    };
}
